function renderForm() {

	/**
	 * Input Numeric
	 */
	$('.form__input.is--numeric').on('input', function () {
		this.value = this.value.replace(/[^0-9]/g, '');
	});

	$('.contact__input.is--numeric').on('input', function () {
		this.value = this.value.replace(/[^0-9]/g, '');
	});

	$('.contact__input.is--pesos').on('input', function () {
		$(this).val(function (index, value ) {
			
			let num = value.replace(/[^0-9]/g, '');

			num = num.toString().split('').reverse().join('').replace(/(?=\d*\.?)(\d{3})/g,'$1.');
			num = num.split('').reverse().join('').replace(/^[\.]/,'');
			
			return num;
		
		});
	});

}